import React, { useState, useRef, useContext  } from "react";
import { style_templates } from "../config_variables/styles";
import {Button,  ScrollView, ActivityIndicator, View, Text,   Pressable,  FlatList, useWindowDimensions } from "react-native";
import Screen1Card from "../components/Screen1Card";
import GridBox from "../components/GridBox";
import Card from "../components/Card";
import { DataContext } from "../store/data-context";
import { variables } from "../config_variables/variables";
import '../config_variables/styles.css';


import { useReactToPrint } from 'react-to-print';

import createDummyGridBox from "../utils/createDummyGridBox";
import createDummyGridRow from "../utils/createDummyGridRow";

function screen2OverallSummary(props) {
  console.log("inside screen2OverallSummary");
  const { height, width } = useWindowDimensions();
  const [screen2FetchComplete, setScreen2FetchComplete] = useState(false);

  const dataCtx = useContext(DataContext);

  React.useEffect(() => {
    console.log("inside useEffect in screen2");
    console.log("screen2FetchComplete : " + screen2FetchComplete);
      if (screen2FetchComplete ) {
            console.log(" inside useEffect of Scree2OverallSummary | stockType : " + dataCtx.stockType + ' | dataCtx.filtercategory:' + dataCtx.filtercategory);            
            dataCtx.analyze_stock()
    } else {
      checkContextAccess();
    }
//   }, [dataCtx.btrData, dataCtx.showPage, dataCtx.liveStockIsEnabled, dataCtx.columnsExpanded]);
}, [dataCtx.btrData, dataCtx.showPage, dataCtx.projectFilter, dataCtx.stageFilter, dataCtx.groupFilter, dataCtx.allocationFilter , dataCtx.stockdata ]);
// }, [dataCtx.gridData]);
  


  function checkContextAccess() {
    console.log("inside checkContextAccess");
    setScreen2FetchComplete(true);
    dataCtx.checkContext();
    dataCtx.getStockData();
  }

  const componentRef = useRef();

  
// function resetApplication() {
//       dataCtx.toggleRowsExpanded(false)
//       dataCtx.toggleColumnsExpanded(false)
//       dataCtx.toggleProjectFilter("")
//       dataCtx.toggleStageFilter("")
//       dataCtx.toggleGroupFilter("")
//       dataCtx.toggleAllocationFilter("")
//       dataCtx.analyze_stock()
// }

    function renderCardsScreen3(itemData) {
      return (
            <Card
            filtercategory={"lot"}
            cardData={itemData.item}
            WINDOW_HEIGHT={height}
            // showLotsHandler={dataCtx.showLotsHandler}
            />
      )
  }

console.log('dataCtx.cardListData.project: '+ JSON.stringify(dataCtx.cardListData.project))
console.log('dataCtx.cardListData.stage: '+ JSON.stringify(dataCtx.cardListData.stage))
console.log('dataCtx.gridData: '+ JSON.stringify(dataCtx.gridData))

let total_rows = 0
let total_columns = 0
if(Object.keys(dataCtx.gridData).length > 0) {
      total_rows = dataCtx.gridData.griddata.length
      console.log(' dataCtx.gridData.griddata.length: ' + dataCtx.gridData.griddata.length)
      if(dataCtx.gridData.griddata.length > 0 ){
            total_columns = Object.keys ( dataCtx.gridData.griddata[0].allocation_counts).length
      }
      // total_columns = dataCtx.gridData.griddata.reduce( (ret, dg) => 
      //       Object.keys(dg.allocation_counts).length + ret, 0
      // )
}

      const mod_height = 1.15 / 9 * (total_rows+2) * height
      // const std_height = total_rows * 0.96 * 100
      const std_height = 9 * 0.96 * 100

      console.log('dataCtx.columnsExpanded: '+ dataCtx.columnsExpanded)
      console.log('dataCtx.rowsExpanded: '+ dataCtx.rowsExpanded)
      console.log('dataCtx.totalCountsData: '+ JSON.stringify(dataCtx.totalCountsData))
      console.log('dataCtx.projectFilter: '+ dataCtx.projectFilter)
      console.log('dataCtx.stageFilter: '+ dataCtx.stageFilter)
      console.log('dataCtx.groupFilter: '+ dataCtx.groupFilter)
      console.log('dataCtx.allocationFilter: '+ dataCtx.allocationFilter)
      console.log('total_rows: ' + total_rows + ' | total_columns : ' +  total_columns + ' | height : ' + height + ' | panel mod_height:  ' + mod_height  + ' |std_height: ' + std_height)
      console.log('dataCtx.waitForProcessing; '  + dataCtx.waitForProcessing)
      console.log('dataCtx.filterArray: ' + JSON.stringify(dataCtx.filterArray))
      console.log('dataCtx.filterArray.length: ' + dataCtx.filterArray.length)
      console.log('dataCtx.printPreviewInd: ' + dataCtx.printPreviewInd)

      /* fillter boxes */
      const data_sanity_check_status = dataCtx.dataFetchComplete &&  Object.keys(dataCtx.totalCountsData).length > 0 && !dataCtx.waitForProcessing 
      if(data_sanity_check_status) {
            console.log('dataCtx.gridData["griddata"].length : ' + dataCtx.gridData["griddata"].length  + ' | Object.keys(dataCtx.gridData["griddata"][0].allocation_counts).length : ' + Object.keys(dataCtx.gridData["griddata"][0].allocation_counts).length)
      }
      const total_rows_in_grid =  data_sanity_check_status ? dataCtx.gridData["griddata"].length : 0
      const total_columns_in_grid = data_sanity_check_status ?  Object.keys(dataCtx.gridData["griddata"][0].allocation_counts).length : 0
      const dummy_row_count =    data_sanity_check_status ? total_rows_in_grid < variables.FIXED_ROW_COUNT ? variables.FIXED_ROW_COUNT - total_rows_in_grid : 0 : 0
      const dummy_column_count = data_sanity_check_status ? total_columns_in_grid < variables.FIXED_COLUMN_COUNT ? variables.FIXED_COLUMN_COUNT - total_columns_in_grid : 0 : 0
      const total_columns_in_dummy_row = dummy_column_count+total_columns_in_grid
      const dummy_columns =  createDummyGridBox(dummy_column_count)
      const dummy_rows =  createDummyGridRow(dummy_row_count, total_columns_in_dummy_row)
      const full_dummy_row = createDummyGridBox( total_columns_in_dummy_row)
      console.log('total_columns_in_grid : ' + total_columns_in_grid + ' | dummy_column_count : ' + dummy_column_count + ' | total_columns_in_dummy_row : ' + total_columns_in_dummy_row + ' | dummy_row_count : ' + dummy_row_count +  ' | dummy_columns: ' + JSON.stringify(dummy_columns) + ' | dummy_rows: ' + JSON.stringify(dummy_rows) + ' | full_dummy_row: ' + JSON.stringify(full_dummy_row))       


      if(dataCtx.waitForProcessing) {
            dataCtx.toggleWaitForProcessing(false)
      }
      // if(dataCtx.columnsExpanded) {
      //       dataCtx.expandColumns()
      // }

      // if(dataCtx.rowsExpanded) {
      //       dataCtx.expandRows()
      // }


  return (
     <View style={style_templates.app_container}>
            <View style={style_templates.app_body_container_screen2}>
                  { (  ( !dataCtx.dataFetchComplete && !dataCtx.serverError  ) || dataCtx.waitForProcessing ) && (
                              <View style={style_templates.loading_state_container}>
                              <Text>Loading...</Text>
                              <ActivityIndicator size="large" />
                              </View>
                  )}


                  { dataCtx.dataFetchComplete &&  Object.keys(dataCtx.totalCountsData).length > 0 && !dataCtx.waitForProcessing && (
                        <>
                              {total_columns <= 8 && !dataCtx.printPreviewInd && (                                    
                              // {!dataCtx.columnsExpanded && (                                    
                                    // <View style={[style_templates.panel_container, {flex: total_columns < 10 ? 3 : 1 }]}>
                                    <View style={[style_templates.panel_container, {flex:  3 }]}>
                                          <View style={style_templates.screen1_header}>
                                                <Text style={style_templates.screen1_header_text}>STOCK BY PROJECT</Text>
                                          </View>
                                          <View style={{height: 750, flexDirection: "column"}}>
                                                <View style={[style_templates.panel1_summary_container, {marginVertical:5, flex:3}]}>
                                                      {Object.keys(dataCtx.totalCountsData).length > 0  && (
                                                            Object.keys(dataCtx.totalCountsData).map((key) => (
                                                                  <View style={style_templates.panel1_summary_container_box}>
                                                                        <View style={style_templates.panel1_summary_container_box_row}>
                                                                              <Text style={style_templates.panel1_summary_container_box_counter}>
                                                                                    {dataCtx.totalCountsData[key]}
                                                                              </Text>
                                                                        </View>
                                                                        <View style={style_templates.panel1_summary_container_box_row}>
                                                                              <Text style={style_templates.panel1_summary_container_box_text}>
                                                                                    { key.substring(1,0).toUpperCase() + key.substring(1, key.length)}s 
                                                                              </Text>
                                                                        </View>
                                                                  </View>
                                                            ))
                                                      )}
                                                </View>

                                                {/* <View style={{ flex:1, flexDirection: "row", marginVertical:5, paddingHorizontal: 10  }}> */}
                                                <View style={[style_templates.panel1_summary_container, {paddingVertical: 5, marginVertical:10, flex:1}]}>
                                                      <View style={{flex :1, marginHorizontal:3}}><Button onPress={dataCtx.toggleStockType} title={"Current "}/></View>
                                                      <View style={{flex :1, marginHorizontal:3}}><Button onPress={dataCtx.toggleStockType} title={"Upcoming"}/></View>
                                                      <View style={{flex :1, marginHorizontal:3}}><Button onPress={dataCtx.removeLastFilter} title={"Back"}/></View>
                                                      <View style={{flex :1, marginHorizontal:3}}><Button onPress={dataCtx.resetApplication} title="RESET"/></View>
                                                </View>

                                                <ScrollView showsVerticalScrollIndicator={false} style={{ marginVertical:15, flex:20, flexDirection: "column"}}>
                                                      { Object.keys(dataCtx.cardListData).length > 0  && dataCtx.cardListData.project.length > 0 && (
                                                            dataCtx.cardListData.project.map( (p, i) => (
                                                                  <Screen1Card key={Math.random()}  color = {variables.screen1_metrics[i].color} icon = {variables.screen1_metrics[i].icon} name={p.name} count={p.count}></Screen1Card>
                                                            ))
                                                      )}
                                                </ScrollView>
{/* 
                                                <ScrollView showsVerticalScrollIndicator={false}  style={[style_templates.filter_panel , {marginVertical:10,  padding: 10, flex:8}]}>
                                                      { 
                                                      dataCtx.filterArray.length > 0 && (
                                                            dataCtx.filterArray.map ( d => (
                                                                  <Text style={{color:"rgb(40, 245, 40)" , fontFamily: "consolas", fontSize: 12}}>
                                                                        Added {d.category} filter {d.value}... {'\n'}  {'\n'} 
                                                                  </Text>
                                                      ))
                                                      )}
                                                      {dataCtx.filterArray.length == 0 && (
                                                            <Text style={{color:"rgb(40, 245, 40)" , fontFamily: "consolas", fontSize: 12}}>
                                                                  No filters added...
                                                            </Text>
                                                      )}
                                                </ScrollView> */}
                                          </View>


                                    </View>
                               )} 

                              {/* <View style={[style_templates.panel_container, {flex:7, height: total_rows < 9 ? mod_height : std_height }]}> */}
                              <View style={[style_templates.panel_container, {flex:5, height: total_rows < 9 ? std_height : std_height }]}>
                                    <View style={style_templates.screen1_header}>
                                          <Text style={style_templates.screen1_header_text}>ALLOCATION GRID</Text>
                                    </View>
                                    
                                    {Object.keys(dataCtx.gridData).length > 0  && (
                                          <>
                                                { dataCtx.gridData.griddata.length > 0 && (                                                      
                                                      <View showsVerticalScrollIndicator={false} style = {[style_templates.grid_container , {height: std_height}]}>      
                                                            <View style = {style_templates.grid_container_row}> 
                                                                  <GridBox 
                                                                        grid_box_type={"corner"}
                                                                  />
                                                                  { Object.keys(dataCtx.gridData["griddata"][0].allocation_counts).map((key, index) => (
                                                                                                                              
                                                                        <GridBox 
                                                                              key= {Math.random()}
                                                                              grid_box_color ={"transparent"} 
                                                                              count={dataCtx.gridData["griddata"].reduce((tot, dgd) => 
                                                                                          dgd['allocation_counts'][key]  + tot , 0,)} 
                                                                              x_axis_label = {key} 
                                                                              y_axis_label={""} 
                                                                              border_width = {1}
                                                                              grid_box_type={"header"}
                                                                              category={'allocation'}
                                                                              // headertype={'allocation'}
                                                                              headertype={dataCtx.columnsExpanded ? 'allocation' : 'group'}
                                                                              font_size= {10}
                                                                              // font_size= {14}
                                                                              // font_color={"rgb(98, 93, 93)"}
                                                                              // font_color={"rgb(135, 113, 215)"}
                                                                              // font_color={"rgb(83, 79, 79)"}
                                                                              // font_color={"rgb(168, 161, 161)"}
                                                                              font_color={"rgb(28, 27, 27)"}
                                                                        />
                                                                  ))}

                                                                  { dummy_column_count > 0 && (
                                                                        Object.keys(dummy_columns).map((key, index) => (
                                                                                                                              
                                                                              <GridBox 
                                                                                    key= {Math.random()}
                                                                                    grid_box_color ={"transparent"} 
                                                                                    count={dataCtx.gridData["griddata"].reduce((tot, dgd) => 
                                                                                                dgd['allocation_counts'][key]  + tot , 0,)} 
                                                                                    x_axis_label = {key} 
                                                                                    y_axis_label={""} 
                                                                                    border_width = {1}
                                                                                    grid_box_type={"cell"}
                                                                                    category={'allocation'}
                                                                                    headertype={dataCtx.columnsExpanded ? 'allocation' : 'group'}
                                                                                    font_size= {14}
                                                                                    font_color={"rgb(246, 238, 238)"}
      
                                                                              />
                                                                        
                                                                        ))
                                                                  )}

                                                            </View>

                                                            {dataCtx.gridData["griddata"].length > 0 && (
                                                                  dataCtx.gridData["griddata"].map ( row => (
                                                                        <View style = {style_templates.grid_container_row}>      
                                                                                    <GridBox 
                                                                                          key= {Math.random ()}
                                                                                          grid_box_color ={"transparent"} 
                                                                                          count={row.name} 
                                                                                          x_axis_label = {
                                                                                                Object.values(row.allocation_counts).reduce((prev, curr) => prev + curr, 0)
                                                                                          } 
                                                                                          y_axis_label={""} 
                                                                                          border_width = {1}
                                                                                          grid_box_type={"header"}
                                                                                          headertype={dataCtx.rowsExpanded ? 'stage' : 'project'}
                                                                                          // headertype={'non-allocation'}
                                                                                          category={'non-allocation'}
                                                                                          font_size= {!dataCtx.rowsExpanded ? 9 : 9}
                                                                                          // font_color={"rgb(98, 93, 93)"}
                                                                                          // font_color={"rgb(83, 79, 79)"}
                                                                                          font_color={"rgb(28, 27, 27)"}


                                                                                          // font_color={"rgb(135, 113, 215)"}
                                                                                          
                                                                                    />
                                                                              { Object.keys(row.allocation_counts).map((key, index) => (
                                                                                    <GridBox 
                                                                                          key= {Math.random()}
                                                                                          // grid_box_color ={"white"} 
                                                                                          grid_box_color ={row.allocation_counts[key] == 0 ? "rgb(246, 238, 238)" : "rgb(165, 212, 165)"} 
                                                                                          // grid_box_color ={variables.colors_array[(Math.random()*5).toFixed(0)]} 
                                                                                          count={row.allocation_counts[key]} 
                                                                                          x_axis_label = {row.name} 
                                                                                          y_axis_label={key} 
                                                                                          border_width = {1}
                                                                                          category={'cell'}
                                                                                          grid_box_type={"cell"}
                                                                                          headertype={"cell"}
                                                                                          // font_size= {!dataCtx.rowsExpanded ? 22 : 10}
                                                                                          // font_size= {!dataCtx.rowsExpanded ? 18 : 14}
                                                                                          font_size= {!dataCtx.rowsExpanded ? 16 : 16}
                                                                                          // font_color={row.allocation_counts[key] == 0 ? "rgb(253, 246, 246)" : "rgb(147, 137, 137)"}
                                                                                          // font_color={row.allocation_counts[key] == 0 ? "rgb(246, 238, 238)" : "white"}
                                                                                          // font_color={row.allocation_counts[key] == 0 ? "rgb(246, 238, 238)" : "rgb(83, 79, 79)"}
                                                                                          font_color={row.allocation_counts[key] == 0 ? "rgb(246, 238, 238)" : "rgb(28, 27, 27)"}
                                                                                          


                                                                                    />                                                                                    
                                                                              ))}
                                                                              { dummy_column_count > 0 && (
                                                                                    Object.keys(dummy_columns).map((key, index) => (
                                                                                                                                          
                                                                                          <GridBox 
                                                                                                key= {Math.random()}
                                                                                                grid_box_color ={"rgb(246, 238, 238)"} 
                                                                                                count={dataCtx.gridData["griddata"].reduce((tot, dgd) => 
                                                                                                            dgd['allocation_counts'][key]  + tot , 0,)} 
                                                                                                x_axis_label = {key} 
                                                                                                y_axis_label={""} 
                                                                                                border_width = {1}
                                                                                                grid_box_type={"cell"}
                                                                                                category={'allocation'}
                                                                                                headertype={dataCtx.columnsExpanded ? 'allocation' : 'group'}
                                                                                                font_size= {14}
                                                                                                font_color={"rgb(246, 238, 238)"}
                  
                                                                                          />
                                                                                    
                                                                                    ))
                                                                              )}                                                                              
                                                                        </View>
                                                                  ))
                                                            )}

                                                            { dummy_row_count > 0 && (
                                                                  dummy_rows.map ( row => (
                                                                  <View style = {style_templates.grid_container_row}>      
                                                                              <GridBox 
                                                                                    key= {Math.random ()}
                                                                                    grid_box_color ={"rgb(246, 238, 238)"} 
                                                                                    count={"dummyRow"} 
                                                                                    x_axis_label = {""} 
                                                                                    y_axis_label={""} 
                                                                                    border_width = {1}
                                                                                    grid_box_type={"cell"}
                                                                                    headertype={dataCtx.rowsExpanded ? 'stage' : 'project'}
                                                                                    // headertype={'non-allocation'}
                                                                                    category={'non-allocation'}
                                                                                    font_size= {!dataCtx.rowsExpanded ? 14 : 12}
                                                                                    // font_color={"rgb(98, 93, 93)"}
                                                                                    font_color={"rgb(246, 238, 238)"}

                                                                                    // font_color={"rgb(135, 113, 215)"}
                                                                                    
                                                                              />

                                                                        { Object.keys(full_dummy_row).length > 0 && (
                                                                              Object.keys(full_dummy_row).map((key, index) => (
                                                                                                                                    
                                                                                    <GridBox 
                                                                                          key= {Math.random()}
                                                                                          grid_box_color ={"rgb(246, 238, 238)"} 
                                                                                          count={dataCtx.gridData["griddata"].reduce((tot, dgd) => 
                                                                                                      dgd['allocation_counts'][key]  + tot , 0,)} 
                                                                                          x_axis_label = {key} 
                                                                                          y_axis_label={""} 
                                                                                          border_width = {1}
                                                                                          grid_box_type={"cell"}
                                                                                          category={'allocation'}
                                                                                          headertype={dataCtx.columnsExpanded ? 'allocation' : 'group'}
                                                                                          font_size= {14}
                                                                                          font_color={"rgb(246, 238, 238)"}

                                                                                    />
                                                                              
                                                                              ))
                                                                        )}                                                                              
                                                                  </View>
                                                            ))
                                                              
                                                            )}


                                                      </View>
                                                )}
                                          </>
                                    )}
                              </View>

                              {/* <View style={[style_templates.panel_container, {flex: dataCtx.columnsExpanded ? 2 : 2 }]}> */}
                              {/* {total_columns <= 8 && !dataCtx.printPreviewInd && (           */}
                                    {/* <View style={[style_templates.panel_container, {flex: total_columns < 10 ? 3 : 1 }]}>
                                          <View style={style_templates.screen1_header}>
                                                <Text style={style_templates.screen1_header_text}>AVAILABLE LOTS</Text>
                                          </View>
                                          <View style={{height: 750, flexDirection: "column"}}>
                                                <ScrollView showsVerticalScrollIndicator={false} style={{ marginTop:10}}>
                                                      <FlatList
                                                            showsVerticalScrollIndicator={false}
                                                            data={dataCtx.cardListDataScreen3}
                                                            keyExtracttor={(item) => item.id}
                                                            renderItem={renderCardsScreen3}
                                                      />                                          
                                                </ScrollView>
                                          </View>


                                    </View>                                       */}
                               {/* )}  */}
                        </>
                  )}
            </View>      
      </View>      
      
  )
                                          }

export default screen2OverallSummary;





     